// import "./App.css";
// import { HashRouter as Router, Routes, Route } from "react-router-dom";

// // import Testing from "./Pages/Testing"
// import MainITSolutionHero from "./Home/ITSolution";
// import TermsCondition from "./Pages/Policies/TermsCondition";
// import CookiesPolicy from "./Pages/Policies/CookiesPolicy";
// import PrivacyPolicy from "./Pages/Policies/PrivacyPolicy";
// import { useEffect } from "react";
// import { useLocation } from "react-router-dom";

// function ScrollToTop() {
//   const { pathname } = useLocation();

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [pathname]);

//   return null;
// }

// function App() {
//   return (
//     <Router>
//       <Routes>
//         {/* <Route path="/testing" element={<Testing />} /> */}
//         <Route path="/" element={<MainITSolutionHero />} />
//         <Route path="policies/terms-conditions" element={<TermsCondition />} />
//         <Route path="policies/cookies" element={<CookiesPolicy />} />
//         <Route path="policies/privacy-policy" element={<PrivacyPolicy />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;


import "./App.css";
import { HashRouter as Router, Routes, Route } from "react-router-dom";

// import Testing from "./Pages/Testing"
import MainITSolutionHero from "./Home/ITSolution";
import TermsCondition from "./Pages/Policies/TermsCondition";
import CookiesPolicy from "./Pages/Policies/CookiesPolicy";
import PrivacyPolicy from "./Pages/Policies/PrivacyPolicy";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />

      <Routes>
        {/* <Route path="/testing" element={<Testing />} /> */}
        <Route path="/" element={<MainITSolutionHero />} />
        <Route path="policies/terms-conditions" element={<TermsCondition />} />
        <Route path="policies/cookies" element={<CookiesPolicy />} />
        <Route path="policies/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  );
}

export default App;